<template>
  <el-dialog title="商品明细" :visible.sync="activeareaDialog" width="90%" top="10vh">
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-select v-model="formData.brandid" placeholder="按品牌" style="width: 100%;" clearable>
          <el-option v-for="item in brandList" :key="item.id" :label="item.showlable" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formData.isgrounding" placeholder="按商品上下架状态" style="width: 100%;">
          <el-option label="上架" value="1"></el-option>
          <el-option label="下架" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请输入关键字" v-model="formData.key" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="getList()">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="listData" v-loading="loading" ref="multipleTable" tooltip-effect="dark">
      <el-table-column prop="sku" label="SKUID"></el-table-column>
      <el-table-column prop="productInfo" label="商品信息" width="400px">
        <template slot-scope="scope">
          <div class="goodsInfo">
            <div class="left">
              <img :src="scope.row.img">
            </div>
            <div class="right">
              <div class="name">{{ scope.row.name }}</div>
              <div class="prop" style="margin-top: 10px;">{{ scope.row.property_name }} {{ scope.row.spec }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="combination_items_name" label="所属搭配" show-overflow-tooltip ></el-table-column>
      <el-table-column prop="brand_name" label="所属品牌"></el-table-column>
      <el-table-column prop="weight" label="重量（kg）"></el-table-column>
      <el-table-column prop="unit" label="单位"></el-table-column>
      <el-table-column prop="property_price" label="批发价格"></el-table-column>
      <el-table-column prop="inventory" label="可用库存"></el-table-column>
      <el-table-column prop="status_name" label="状态"></el-table-column>
    </el-table>
    <div class="block" style="display: flex;width: 100%;justify-content: flex-end;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="formData.p" :page-sizes="[10, 20, 50]" :page-size="formData.rollpage"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="批量上下架组合" :visible="showIsOnShelf" width="400px" :modal="false" :modal-append-to-body="false"
      @close="showIsOnShelf = false">
      <el-select v-model="isOnShelfCheckbox" placeholder="请选择" style="width: 100%;">
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <template slot="footer">
        <el-button type="primary">确定</el-button>
        <el-button @click="showIsOnShelf = false">取消</el-button>
      </template>
    </el-dialog>
  </el-dialog>

  <!-- 批量上下架 -->
</template>
<script>
export default {
  data() {
    return {
      showIsOnShelf: false,
      activeareaDialog: false,
      isOnShelfCheckbox: '',
      formData: {
        act: 'combination_goods_info',
        id: '',
        key: '',
        brandid: '',
        isgrounding: '',
        p: 1,
        rollpage: 10
      },
      total: 0,
      listData: [],
      loading: false,
      brandList: []
    }
  },
  mounted() {
    this.getBrand()
  },
  methods: {
    // 获取列表
    getList(row) {
      if (row) {
        this.formData.id = row.id
        this.formData.brandid = ""
        this.formData.isgrounding = ""
        this.formData.key = ""
        this.formData.p = 1
      }
      this.activeareaDialog = true
      this.loading = true
      this.$axios({
        url: this.GLOBAL.domain + 'Combination/index',
        method: 'GET',
        params: {
          ...this.formData,
          id: this.formData.id
        }
      })
        .then(res => {
          console.log(res, 'RRRRRRRRRRRRRRRRRRR')
          this.total = +res.count || 0
          this.listData = res.Data
        })
        .finally(() => {
          this.loading = false
        });
    },
    handleSizeChange(val) {
      this.formData.rollpage = val;
      this.formData.p = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formData.p = val;
      this.getList();
    },
    // 获取品牌
    getBrand() {
      this.$axios({
        url: this.GLOBAL.domain + 'Brand/index',
        method: 'GET',
        params: {
          act: 'lists',
          rollpage: 1000
        }
      })
        .then(res => {
          this.brandList = res.Data
        })
    }
  }
}
</script>

<style scoped>
.goodsInfo {
  display: flex;
  align-items: center;
}

.goodsInfo .left {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  margin-right: 10px;
}

.goodsInfo .left img {
  width: 100%;
  height: 100%;
}

.goodsInfo .prop {
  color: #a1a1a1;
}
</style>


// WEBPACK FOOTER //
// src/components/mall/CombinationDetail.vue